import React from "react";
import HeaderAyuda from "../../../ComponentsNav/Header/HeaderAyuda";
import FooterAyuda from "../../../ComponentsNav/Footer/FooterAyuda";
import "../ayuda.css";
import "../../../ComponentsNav/MenuSidebar/menu.css";
import { withRouter } from "react-router";
import MenuSidebar from "../../../ComponentsNav/MenuSidebar";
import MenuLink from "../../../ComponentsNav/MenuLink";

class Contenido extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cargando: false, opciones: [], opcion: {} };
  }

  componentDidMount() {
    let self = this;
    self.setState({ cargando: true });
    fetch(process.env.REACT_APP_JSON_OPCIONES)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        let tmp = JSON.parse(data);
        let opcion = tmp.filter((x) => x.hash === self.props.location.hash);
        self.setState({ cargando: false, opciones: tmp, opcion: opcion[0] });
      })
      .catch(function (err) {
        console.error(err);
        self.setState({ cargando: false });
      });
    this.unlisten = this.props.history.listen((location) => {
      self.cambioRuta(location);
    });
  }

  cambioRuta(location) {
    let opcion = this.state.opciones.filter((x) => x.hash === location.hash);
    this.setState({ opcion: opcion[0] });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    return (
      <div className={"container__font--" + this.props.marca}>
        <HeaderAyuda marca={this.props.marca}></HeaderAyuda>
        <div className="container-fluid form__container--sup">
          <div className="container">
            <div
              className={
                "form__container form__container--ayuda container--" +
                this.props.marca
              }
            >
              <div className="form__container--ayuda-global">
                {this.state.opciones.length > 0 && (
                  <MenuSidebar
                    opciones={this.state.opciones}
                    fecha={this.state.opcion.actualizacion}
                  />
                )}
                <div className="container-fluid">
                  {this.state.opciones.length > 0 && (
                    <MenuLink opciones={this.state.opciones} />
                  )}
                  {this.state.opcion !== undefined && (
                    <div className="form__container-ayuda-global-contenido">
                      <div className="row">
                        <div className="col-12">
                          <h2 className="form__container-ayuda-global-titulo">
                            {this.state.opcion.titulo}
                          </h2>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 mt-3 mb-3">
                          <p className="form__container-ayuda-global-texto">
                            {this.state.opcion.descripcion}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <h5>
                            <b>{this.state.opcion.subtitulo}</b>
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <p className="form__container-ayuda-global-texto" dangerouslySetInnerHTML={ { __html: this.state.opcion.descripcion2 } }>
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={
                            this.state.opcion.subtitulo2 !== ""
                              ? "col-md-3 col-12"
                              : "col-0"
                          }
                        >
                          <h6 className="form__container-ayuda-global-subtitulo">
                            <b>{this.state.opcion.subtitulo2}</b>
                          </h6>
                          <p className="form__container-ayuda-global-texto">
                            {this.state.opcion.descripcion3}
                          </p>
                        </div>
                        <div
                          className={
                            this.state.opcion.subtitulo2 !== ""
                              ? "col-md-9 col-12 text-center"
                              : "col-12 text-center"
                          }
                        >
                          {this.state.opcion.contenido !== undefined ? (
                            this.state.opcion.contenido.includes(".pdf") > 0 ? (
                              <object width="100%" data={this.state.opcion.contenido} type="application/pdf" height="600px" frameborder="0"> 
                                  <p>Si no puedes ver correctamente este PDF <a target="_blank" rel="noreferrer" href={this.state.opcion.contenido}>visualizalo aqui!</a></p>
                                  <embed src={this.state.opcion.contenido} width="100%" height="600px"/>
                              </object>
                            ) : (
                              this.state.opcion.contenido.includes(".mp4") > 0 ? (<video width="100%" height="500" controls >
                              <source src={this.state.opcion.contenido} type="video/mp4"/>
                             </video>
                              ):(<a href={this.state.contenido} className="form__container-ayuda-global-link" alt="contenido">Haga click aquí para descargar el archivo!</a>)
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            "page__cargando" + (this.state.cargando ? " d-block" : " d-none")
          }
        ></div>
        <FooterAyuda marca={this.props.marca}></FooterAyuda>
      </div>
    );
  }
}

export default withRouter(Contenido);
